import React from 'react'
import './PrivacyPolicy.css'

function PrivacyPolicy() {
    return (
        <div className="privacypolicy">
            <h1>Privacy Policy</h1>
            <div>
                <div className="privacypolicy__content">
                    <h3>1 General</h3>
                    <div className="privacypolicy__p">
                        <p>We will only process your personal data in accordance with the applicable privacy laws. The following privacy policy will inform you about the type, scope and purpose of the collection, processing and use of personal data by Morning Ideas s.r.o. </p>
                    </div>
                </div>
                <div className="privacypolicy__content">
                    <h3>WHY DO CUSTOMERS LOVE US?</h3>
                    <div className="privacypolicy__p">
                        <p>We have been in the business for quite a while now, and it that time we have not only managed to make close relationships with numerous suppliers all over the world, but also to recognize what people need. This means that we are always able to offer all the latest phones, great prices, reliable service, fast delivery and premium customer support.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PrivacyPolicy;
